<template>
  <div class="corpo-pagina">
    <div class="row">
      <div class="col s12 m10 offset-m1 content-container">

        <!-- Intestazione e Pulsante -->
        <div class="row valign-wrapper mb-2">
          <div class="col s8">
            <h4 class="page-title">{{ translation('event.card.title.gestione.tavoli')  }}</h4>
          </div>
          <div class="col s4 right-align">
            <button
              class="btn-large new-event-btn"
              @click="goToCreateRoom"
            >
              {{ translation('btn.new.room') }}
              <i class="material-icons right">add</i>
            </button>
          </div>
        </div>

        <div class="divider"></div>

        <!-- Tabella Dati -->
        <div v-if="roomData && roomData.length > 0">
          <table class="highlight responsive-table">
            <thead>
              <tr>
                <th>{{ translation('header.table.room.name') }} </th>
                <th>{{ translation('header.table.room.description') }}</th>
                <th>{{ translation('header.table.room.color') }}</th>
                <th>{{ translation('header.table.room.ambiant') }}</th>
                <th class="center-align">{{ translation('header.table.room.actions') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="room in roomData" :key="room.uid">
                <td><strong>{{ room.name || 'N/D' }}</strong></td>
                <td>{{ room.description || 'N/D' }}</td>
                <td>
                  <span
                    class="color-badge"
                    :style="{ backgroundColor: room.color || '#9e9e9e' }"
                  >
                    {{ room.color || 'N/D' }}
                  </span>
                </td>
                <td>
                  <span v-if="!room.img">N/D</span>
                  <div v-else class="image-wrapper">
                    <img
                      :src="showImg(room.img)"
                      alt="background room"
                      class="room-thumbnail"
                    />
                  </div>
                </td>
                <td class="center-align">
                  <!-- Pulsante per salvare il konva_schema e aprire il TableManager -->
                  <button
                    class="btn-flat waves-effect"
                    @click="goToStage(room)"
                    title="manage table"
                  >
                    <i class="material-icons">launch</i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Stato vuoto / Fallimento -->
        <div v-else-if="!loadingStore.getters.isLoading" class="center-align" style="margin-top: 30px;">
          <p class="grey-text">{{ translation('msg.list.room.empty') }}</p>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import loadingStore from '@/store/loading'
import useAuthStore from '@/store/authStore.js'
import apiService from '@/services/apiService.js'
import eventSetting from '@/store/eventSettings.js'
import konovaschema from '@/store/konovaschema.js'
import translationStore from '@/store/translations'

export default {
  name: 'ListRoom',
  data () {
    return {
      loadingStore,
      translationStore: translationStore,
      roomData: []
    }
  },
  computed: {
    isAuth () {
      return useAuthStore.getters.isAuthenticated
    },
    fullEventData () {
      return eventSetting.getters.eventModel || {}
    },
    uidEvent () {
      return this.fullEventData.uid || null
    },
    translation () {
      return this.translationStore.getters.traduzione
    }
  },
  watch: {
    uidEvent: {
      immediate: true,
      handler (newUid) {
        if (newUid && this.roomData.length === 0) {
          this.loadingStore.commit('setLoading', true)
          this.loadRoomDetails()
        }
      }
    }
  },
  methods: {
    showImg (img) {
      return process.env.VUE_APP_URL_DOMAIN + '/img/table/' + img + '.png'
    },
    goToCreateRoom () {
      this.$router.push('/create-room')
    },
    goToStage (room) {
      // console.log('Room selezionata per il salvataggio:', room)

      let konvaSchema = null
      if (room.jsonable && room.jsonable.konva_schema) {
        konvaSchema = room.jsonable.konva_schema
      } else if (room.konva_schema) {
        konvaSchema = room.konva_schema
      } else if (room.jsonable && room.jsonable.className === 'Stage') {
        konvaSchema = room.jsonable
      } else if (room.className === 'Stage') {
        konvaSchema = room
      }

      if (konvaSchema) {
        localStorage.setItem('activeTableSchema', JSON.stringify(konvaSchema))
        konovaschema.dispatch('aggiornakonova', konvaSchema)
      } else {
        // console.warn('Nessun konva_schema trovato nella stanza, genero uno schema di default.')
        const defaultSchema = {
          className: 'Stage',
          attrs: { width: 800, height: 600 },
          children: [
            {
              className: 'Layer',
              children: [{ className: 'Rect', attrs: { id: 'stage-border', width: 800, height: 600, stroke: 'black' } }]
            },
            {
              className: 'Layer',
              attrs: { name: 'TableLayer' },
              children: [{ className: 'Transformer', attrs: { anchorFill: 'blue', anchorStroke: 'blue', borderStroke: 'blue', enabledAnchors: [] } }]
            },
            {
              className: 'Layer',
              attrs: { name: 'FigureLayer' },
              children: []
            }
          ]
        }
        localStorage.setItem('activeTableSchema', JSON.stringify(defaultSchema))
        konovaschema.dispatch('aggiornakonova', defaultSchema)
      }

      const roomInfo = {
        uid: room.uid,
        name: room.name,
        description: room.description,
        color: room.color || null,
        img: room.img || null,
        jsonable: room.jsonable || null,
        event_uid: room.event_uid || room.event_id || this.uidEvent
      }

      localStorage.setItem('activeTableInfo', JSON.stringify(roomInfo))
      konovaschema.commit('setRoomData', roomInfo)

      this.$router.push(`/table-manager/${room.uid}`)
    },
    async loadRoomDetails () {
      const token = await apiService.getClientCredentialsToken()

      if (!token) {
        this.$router.push('/error')
        this.loadingStore.commit('setLoading', true) // o false in base al codice originale
        return
      }

      const uid = this.uidEvent
      const url = `${process.env.VUE_APP_URL_EVENTS}/table/list-room/${uid}`

      try {
        const json = await apiService.sendRequestWithBearer('GET', url, token, null)
        this.roomData = Array.isArray(json) ? json : (json ? [json] : [])

        // ---> AGGIUNTA PER SINCRONIZZARE LE STANZE GLOBALMENTE <---
        const settingsString = localStorage.getItem('SettingsStore')
        if (settingsString) {
          const settings = JSON.parse(settingsString)
          if (!settings.eventModel) {
            settings.eventModel = {}
          }
          // Salviamo tutte le sale con i relativi jsonable (e seatOccupancy) nel SettingsStore
          settings.eventModel.rooms = this.roomData
          localStorage.setItem('SettingsStore', JSON.stringify(settings))
        }
        // ----------------------------------------------------------
      } catch (error) {
        // console.error('Errore durante il caricamento dei dettagli della stanza:', error)
        this.$router.push('/error')
      } finally {
        this.loadingStore.commit('setLoading', false)
      }
    }
  },
  mounted () {
    if (!this.uidEvent) {
      this.loadingStore.commit('setLoading', true)
    }
  }
}
</script>

<style scoped>
.content-container {
  padding: 24px;
  line-height: 1.6;
  color: #333;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  margin-top: 20px;
}

.color-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  color: #fff;
  font-size: 0.85rem;
}

.room-thumbnail {
  max-width: 45px;
  max-height: 45px;
  object-fit: cover;
  border-radius: 3px;
  border: 1px solid #ddd;
  margin-left: 10px;
  vertical-align: middle;
}

.image-wrapper {
  display: flex;
  align-items: center;
}
</style>
